<script>
import { casusLabels } from "@/components/article/dictsys/inflectionSchemes/german/labels";
import { mergeInflections } from "@/components/article/dictsys/inflectionSchemes/german/merge-inflections";

export default {
  name: "PersonalInflectionScheme",
  props: {
    scheme: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      casusLabels
    };
  },
  methods: {
    mergeInflections
  }
};
</script>

<template>
  <table class="table inflection-scheme-modal__table">
    <thead>
      <tr>
        <th scope="col" class="inflection-scheme-modal__th">Kasus</th>
        <th scope="col" class="inflection-scheme-modal__th" />
      </tr>
    </thead>
    <tbody>
      <tr v-for="(casus, key) in scheme" :key="key" class="inflection-scheme-modal__tr">
        <td class="inflection-scheme-modal__td">
          {{ casusLabels[key] }}
        </td>
        <td class="inflection-scheme-modal__td" lang="de">
          {{ mergeInflections(casus) }}
        </td>
      </tr>
    </tbody>
  </table>
</template>
